import React, { useMemo } from 'react';
import CanvasConnectionsLayer from './CanvasConnectionsLayer';
import CanvasFrameElement from './CanvasFrameElement';
import CanvasStage from './CanvasStage';
import { boxForFrame, overviewBox } from './canvasSelectors';
import usePrefersReducedMotion from './usePrefersReducedMotion';
import type { CanvasBoardDetail } from '../types';

interface Props {
  board: CanvasBoardDetail;
  currentItemId: string | null;
  isOverview: boolean;
  blackout: boolean;
}

/**
 * Samenstelling voor het beamerscherm (LivePresenterPage): bepaalt het
 * cameradoel (overzicht of een specifiek frame) en rendert de frames en
 * verbindingslijnen op het bord dat CanvasStage rondrijdt.
 */
export default function CanvasPlayerStage({ board, currentItemId, isOverview, blackout }: Props) {
  const reducedMotion = usePrefersReducedMotion();

  const targetBox = useMemo(() => {
    if (isOverview) return overviewBox(board.frames);
    const frame = board.frames.find((f) => f.id === currentItemId);
    return frame ? boxForFrame(frame) : overviewBox(board.frames);
  }, [isOverview, currentItemId, board.frames]);

  return (
    <div className="canvas-player-stage">
      <CanvasStage
        board={{ width: board.width, height: board.height }}
        targetBox={targetBox}
        reducedMotion={reducedMotion}
        blackout={blackout}
      >
        <CanvasConnectionsLayer frames={board.frames} connections={board.connections} board={board} visible={isOverview} />
        {board.frames.map((frame) => (
          <CanvasFrameElement key={frame.id} frame={frame} />
        ))}
      </CanvasStage>
      <div className={`canvas-blackout-overlay${blackout ? ' canvas-blackout-overlay--active' : ''}`} />
    </div>
  );
}
